import React, { useEffect, useState } from "react";
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import profilePhoto from "../../images/profilePhoto.png";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import Rating from "@mui/material/Rating";
import { servicefeature } from "../../styles/style";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import ReviewCard from "../../assets/cards/ReviewCard";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getServiceById } from "../../actions/userAuth";

export default function ServiceDetails() {
  const [service, setService] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getServiceById({ id }, (data) => {
      setService(data.data.data);
    }))
  }, [id]);
  return (
    <>
      <Layout>
        <UserLayout userRole={"candidate"}>
          <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Service Details</Typography>
            <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
              {/* <TextField
                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                className='profile-skills-box text2Light'
                variant="outlined"
                size="small"
                placeholder="Search"

                InputProps={{
                  endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                }}
              /> */}
            </Grid>
          </Box>
          <Grid container spacing={2}>
            <Grid item md={8.5}>
              <Box p={3}>
                <Paper
                  sx={{
                    width: "100%",
                    bgcolor: "#F8FAFF",
                    boxShadow:
                      "0px 40.30877685546875px 80.6175537109375px -15.115790367126465px #3665D014",
                    border: "1.72px solid #cedefd",
                  }}
                >
                  <Box sx={{ p: 3, display: "flex", flexDirection: { md: 'row', xs: 'column' }, justifyContent: "center" }}>
                    <Box>
                      <img
                        src={service?.coach?.avatar}
                        alt="profilePhoto"
                        style={{ height: "200px" }}
                      />
                    </Box>
                    <Box sx={{ fontFamily: "Inter", px: 3 }}>
                      <Typography
                        sx={{
                          lineHeight: "43px",
                          opacity: ".5",
                        }}
                        className="text1Mid"
                      >
                        (0)
                      </Typography>
                      <Typography
                        sx={{
                          lineHeight: "40px",
                          color: "#061C3D",
                        }}
                        className="subHeading2Bold"
                      >
                        {service?.coach?.name}
                      </Typography>
                      <Rating
                        name="half-rating-read"
                        defaultValue={4}
                        precision={0.5}
                        readOnly
                        className="text1Bold"
                        sx={{ py: 1 }}
                      />
                      <Typography
                        sx={{
                          lineHeight: "35px",
                        }}
                        className=""
                      >
                        {service?.coach?.description}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
                <Box my={"5"}>
                  <Typography
                    sx={{
                      lineHeight: "5rem",
                      textAlign: "left",
                    }}
                    className="subHeading1Bold"
                  >
                    About {service?.coach?.name}
                  </Typography>
                  <Typography
                    sx={{
                      lineHeight: "2rem",
                      textAlign: "left",
                    }}
                    className="subHeading2Mid"
                  >
                    {service?.coach?.description}
                  </Typography>
                </Box>

                <Paper
                  sx={{
                    border: "1.28px solid #D2D2D24D",
                    boxShadow:
                      "0px 40.996337890625px 81.99267578125px -15.373626708984375px #3665D014",
                    my: 3,
                  }}
                >
                  <Box p={3}>
                    <Box>
                      <Typography
                        sx={{
                          lineHeight: "4.25rem",
                          textAlign: "left",
                          mt: 1,
                        }}
                        className="subHeading2Bold"
                      >
                        Service Detail
                      </Typography>
                      <Typography
                        sx={{
                          lineHeight: "4.25rem",
                          textAlign: "left",
                          mt: 1,
                        }}
                        className="subHeading2Bold"
                        dangerouslySetInnerHTML={{__html: service?.descriptionByCoach}}>
                        
                      </Typography>
                    </Box>
                    <Box>
                      <Typography
                        sx={{
                          lineHeight: "4rem",
                          textAlign: "left",
                          mt: 1,
                        }}
                        className="heading2bold"
                      >
                        Service Detail by Coach
                      </Typography>
                      <Typography
                        sx={{
                          lineHeight: "4.25rem",
                          textAlign: "left",
                          mt: 1,
                        }}
                        className="subHeading2Bold"
                        dangerouslySetInnerHTML={{__html: service?.descriptionByCoach}}>
                      </Typography>
                    </Box>
                    <Box>
                      <Box>
                        <Typography
                          sx={{
                            lineHeight: "5rem",
                            textAlign: "left",
                            mt: 1,
                          }}
                          className="heading2bold"
                        >
                          Medium Available
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: { md: 'row', xs: 'column' }, justifyContent: 'space-around', gap: { md: 0, xs: 2 } }}>
                          <Box
                            sx={{
                              bgcolor: "#2544EE",
                              color: "#fff",
                              px: 4,
                              py: 1,
                              height: '45px',
                              maxWidth: '90px',
                              borderRadius: "30px",
                            }}
                          >
                            <VideocamRoundedIcon />
                          </Box>

                          <Box sx={servicefeature}>
                            <Typography
                              sx={{ px: 5, py: 3, }}
                              className="text1Mid"
                            >
                              Language:{" "}
                              <span style={{ color: "#2544EE" }}>{service?.language && service?.language.length > 0 && service?.language[0]}</span>
                            </Typography>
                          </Box>
                          <Box sx={servicefeature}>
                            <Typography
                              sx={{ px: 5, py: 3 }}
                              className="text1Mid"
                            >
                              Number of Session:{" "}
                              <span style={{ color: "#2544EE" }}>{service?.numberOfSessions}</span>
                            </Typography>
                          </Box>
                        </Box>
                      </Box>

                      <Box sx={{ display: "flex", flexDirection: { md: 'row', xs: 'column' }, pt: 5, gap: 3, ml: 5, justifyContent: 'end' }}>

                        <Box sx={servicefeature}>
                          <Typography
                            sx={{ px: 5, py: 3 }}
                            className="text1Mid"
                          >
                            Service Duration :
                            <span style={{ color: "#2544EE" }}>{service?.totalDuration} Minutes</span>
                          </Typography>
                        </Box>
                        <Box sx={servicefeature}>
                          <Typography
                            sx={{ px: 5, py: 3 }}
                            className="text1Mid"
                          >
                            Duration/Session: :
                            <span style={{ color: "#2544EE" }}>{service?.totalDuration / service?.numberOfSessions}</span>
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      bgcolor: "#F8FAFF",
                      border: "1px solid #D2D2D299",
                      my: 5,
                      boxShadow:
                        "0px 22.98290252685547px 45.96580505371094px -8.6185884475708px #3665D014",
                    }}
                  >
                    <Typography
                      sx={{
                        py: 3,
                        textAlign: "center",
                      }}
                      className="heading2bold"
                    >
                      Price: ₹{service?.earnedPrice}/-
                    </Typography>
                  </Box>
                  <Box sx={{ textAlign: "center" }}>
                    <Button
                      variant="contained"
                      className="text1Mid"
                      sx={{
                        px: 5,
                        py: 2,
                        bgcolor: "#2544EE",
                        borderRadius: "10px",
                        mb: 5,
                      }}
                      endIcon={<KeyboardArrowRightIcon />}
                      onClick={() => navigate(`/candidate/service-details2/${service._id}`)}
                    >
                      Buy Now
                    </Button>

                  </Box>
                </Paper>
              </Box>
            </Grid>
            <Grid item md={3.5}>
              <Box py={5}>
                <Typography
                  sx={{
                    fontfamily: "Inter",
                    fontSize: "25px",
                    fontWeight: 600,
                    lineHeight: "75px",
                  }}
                >
                  Social Media
                </Typography>
                <Stack direction="row" spacing={1}>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <FacebookRoundedIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <TwitterIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <LinkedInIcon />
                  </IconButton>
                  <IconButton sx={{ bgcolor: "#2544EE", color: "#fff" }}>
                    <InstagramIcon />
                  </IconButton>
                </Stack>
                <Box>
                  <Typography
                    sx={{
                      fontfamily: "Inter",
                      fontSize: "25px",
                      fontWeight: 600,
                      lineHeight: "75px",
                    }}
                  >
                    Reviews
                  </Typography>
                  <Grid container spacing={2}>
                    {
                      service?.reviews && service?.reviews.length > 0
                        ?
                        <Grid item md={12}><ReviewCard /></Grid>
                        :
                        <Grid item md={12}>
                          <Typography align="center">No reviews</Typography>
                        </Grid>
                    }
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </UserLayout>
      </Layout>
    </>
  );
}
